/*
  File: assets/littleg-upload-workspace.js
  Contract: LITTLEG-UPLOAD-U01-U06-FRONTEND-RC-20260730
  Owner: LittleG Upload workspace state, data hydration, processing-step projection and transport boundary.
  Boundary: Liquid owns semantic DOM; this file does not create U02-U06 view containers,
  does not fetch directly, and does not own backend, auth, game, customer, GFun or navigation.
*/
(function (window, document) {
  'use strict';

  var VERSION = '2026-07-30-u01-lifecycle-alignment-02';
  var ROOT_SELECTOR = '[data-littleg-upload-workspace]';
  var MAX_FILE_SIZE = 10485760;
  var existingRuntime = window.LittleGUploadWorkspace;

  if (existingRuntime && existingRuntime.VERSION === VERSION && typeof existingRuntime.boot === 'function') {
    existingRuntime.boot(document);
    return;
  }
  if (existingRuntime && typeof existingRuntime.dispose === 'function') existingRuntime.dispose();

  var workspaceBindings = new WeakMap();
  var MIME_BY_EXTENSION = Object.freeze({
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    pdf: 'application/pdf'
  });

  var UI_STATES = Object.freeze({
    EMPTY: 'empty',
    FILE_SELECTED: 'file_selected',
    LOADING: 'loading',
    ERROR: 'error',
    OFFLINE: 'offline',
    MANUAL: 'manual',
    REVIEW: 'review',
    PACKING: 'packing',
    PREP: 'prep',
    CONFIRM: 'confirm',
    RECORDS: 'records'
  });

  var RECOGNITION_STATES = Object.freeze({
    CLEAR: 'clear',
    NEEDS_CONFIRMATION: 'needs_confirmation',
    UNCERTAIN: 'uncertain',
    NOT_FOUND: 'not_found'
  });

  var GUARDIAN_STATES = Object.freeze({
    PENDING: 'pending',
    CONFIRMED: 'confirmed',
    MANUALLY_EDITED: 'manually_edited',
    REMOVED: 'removed'
  });

  var RECOGNITION_LABELS = Object.freeze({
    clear: '辨識清晰',
    needs_confirmation: '請家長確認',
    uncertain: '內容可能不完整',
    not_found: '未能從通告找到'
  });

  var GUARDIAN_LABELS = Object.freeze({
    pending: '尚未確認',
    confirmed: '家長已確認',
    manually_edited: '已由家長修改',
    removed: '已移除'
  });

  var FIELD_LABELS = Object.freeze({
    activity_name: '活動名稱',
    activity_date: '活動日期',
    activity_time: '活動時間',
    location: '地點',
    required_items: '需要攜帶',
    school_name: '學校',
    class_name: '班別',
    child_name: '小朋友',
    note: '備註'
  });

   var REQUIRED_REVIEW_FIELDS = Object.freeze([
    'activity_name',
    'activity_date',
    'activity_time',
    'location',
    'required_items'
  ]);

  var PACKING_GROUP_LABELS = Object.freeze({
    required: '通告要求',
    suggested: '小G建議',
    custom: '家長新增'
  });



  var STATE_FOCUS_SELECTORS = Object.freeze({
    empty: '[data-upload-empty-heading]',
    file_selected: '[data-upload-primary-action]',
    loading: '[data-upload-loading-heading]',
    error: '[data-upload-error-heading], [data-upload-error-summary]',
    offline: '[data-upload-offline-heading]',
    manual: '[data-manual-activity-name]',
    review: '[data-upload-review-heading]',
    packing: '[data-upload-packing-heading]',
    prep: '[data-upload-prep-heading]',
    confirm: '[data-upload-confirm-heading]',
    records: '[data-upload-records-heading]'
  });

  var STEP_BY_STATE = Object.freeze({
    empty: 'u01',
    file_selected: 'u01',
    loading: 'u01',
    error: 'u01',
    offline: 'u01',
    manual: 'u01',
    review: 'u02',
    packing: 'u03',
    prep: 'u04',
    confirm: 'u05',
    records: 'u06'
  });

  var LOADING_OPERATIONS = Object.freeze({
    parse: {
      kicker: '文件 · 安全整理中',
      title: '正在讀取文件',
      message: '正在整理日期、時間、地點和物品；完成後會交由家長逐欄確認。',
      announcement: '正在讀取文件',
      steps: [
        { title: '上傳通告', status: '已完成', state: 'completed' },
        { title: '讀取文字', status: '進行中', state: 'active' },
        { title: '整理關鍵資料', status: '等待中', state: 'waiting' },
        { title: '家長確認後生成清單', status: '下一步', state: 'waiting' }
      ]
    },
    generate: {
      kicker: '今日要帶咩 · 清單整理中',
      title: '正在生成帶物清單',
      message: '正在根據你已核對的通告，整理通告要求、小G建議及家長新增項目。',
      announcement: '正在生成帶物清單',
      steps: [
        { title: '上傳通告', status: '已完成', state: 'completed' },
        { title: '核對關鍵資料', status: '已完成', state: 'completed' },
        { title: '整理帶物項目', status: '進行中', state: 'active' },
        { title: '建立帶物清單', status: '等待中', state: 'waiting' }
      ]
    },
    confirm: {
      kicker: '家庭記錄 · 安全保存中',
      title: '正在保存家長確認',
      message: '正在保存已核對的通告、帶物清單和準備狀態；請不要重複提交。',
      announcement: '正在保存家長確認',
      steps: [
        { title: '核對通告', status: '已完成', state: 'completed' },
        { title: '完成逐項準備', status: '已完成', state: 'completed' },
        { title: '保存家長確認', status: '進行中', state: 'active' },
        { title: '建立家庭記錄', status: '等待中', state: 'waiting' }
      ]
    }
  });

  function notConfigured() {
    var error = new Error('provider_unavailable');
    error.code = 'provider_unavailable';
    error.user_message = '自動服務尚未配置。請稍後重試，或改為手動建立清單。';
    return Promise.reject(error);
  }

  window.LittleGUploadTransport = window.LittleGUploadTransport || {
    configured: false,
    parseNotice: notConfigured,
    generatePackingList: notConfigured,
    confirmNotice: notConfigured
  };

  function queryAll(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function rootsIn(scope) {
    var target = scope || document;
    var roots = [];
    if (target.matches && target.matches(ROOT_SELECTOR)) roots.push(target);
    if (target.querySelectorAll) {
      queryAll(target, ROOT_SELECTOR).forEach(function (root) {
        if (roots.indexOf(root) === -1) roots.push(root);
      });
    }
    return roots;
  }

  function asArray(value) {
    if (value == null) return [];
    return Array.isArray(value) ? value : [value];
  }

  function stringValue(value) {
    return value == null ? '' : String(value);
  }

  function extensionOf(name) {
    var match = stringValue(name).toLowerCase().match(/\.([a-z0-9]+)$/);
    return match ? match[1] : '';
  }

function formatBytes(bytes) {
    var size = Number(bytes || 0);
    if (size < 1024) return size + ' B';
    if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
    return (size / (1024 * 1024)).toFixed(2) + ' MB';
  }

  function formatHongKongDateTime(value) {
    var raw = stringValue(value).trim();
    if (!raw || raw === '—') return '—';
    var date = new Date(raw);
    if (Number.isNaN(date.getTime())) return raw;

    try {
      return new Intl.DateTimeFormat('zh-HK', {
        timeZone: 'Asia/Hong_Kong',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'short',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      }).format(date);
    } catch (_) {
      return raw;
    }
  }

  function validateFile(file, source) {
    if (!file) {
      return { ok: false, code: 'missing_file', title: '未選擇檔案', message: '請先選擇 JPG、PNG 或 PDF 通告。' };
    }

    var size = Number(file.size);
    if (!Number.isFinite(size) || size <= 0) {
      return { ok: false, code: 'empty_file', title: '檔案內容為空', message: '請重新選擇大小大於 0 byte 的通告檔案。' };
    }

    if (size > MAX_FILE_SIZE) {
      return { ok: false, code: 'file_too_large', title: '檔案超過大小限制', message: '單一檔案上限為 10 MiB。請壓縮文件或重新選擇。' };
    }

    var extension = extensionOf(file.name);
    var expectedMime = MIME_BY_EXTENSION[extension];
    var actualMime = stringValue(file.type).toLowerCase();

    if (!expectedMime || expectedMime !== actualMime) {
      return { ok: false, code: 'unsupported_file', title: '不支援此檔案格式', message: '檔案副檔名必須與 MIME 類型完全一致，只支援 JPG、PNG 及 PDF。' };
    }

    if (source === 'pdf' && extension !== 'pdf') {
      return { ok: false, code: 'unsupported_file', title: '請選擇 PDF 文件', message: '「上傳 PDF」只接受 application/pdf 的 .pdf 文件。' };
    }

    if ((source === 'camera' || source === 'library') && extension === 'pdf') {
      return { ok: false, code: 'unsupported_file', title: '請選擇圖片', message: '拍攝或相簿入口只接受 JPG 或 PNG 圖片。' };
    }

    return { ok: true, extension: extension, mime: actualMime, size: size };
  }

  function createFieldModel(key, value, recognitionState, sourceExcerpt, guardianState) {
    var safeRecognition = RECOGNITION_LABELS[recognitionState] ? recognitionState : RECOGNITION_STATES.NOT_FOUND;
    var safeGuardian = GUARDIAN_LABELS[guardianState] ? guardianState : GUARDIAN_STATES.PENDING;

    return {
      key: stringValue(key),
      label: FIELD_LABELS[key] || stringValue(key),
      value: stringValue(value),
      recognition_state: safeRecognition,
      guardian_state: safeGuardian,
      source_excerpt: stringValue(sourceExcerpt)
    };
  }

  function canonicalNoticeFieldKey(value) {
    var key = stringValue(value).trim();
    var aliases = {
      meeting_time: 'activity_time',
      time: 'activity_time',
      meeting_place: 'location',
      venue: 'location',
      place: 'location',
      event_name: 'activity_name',
      date: 'activity_date',
      bring_items: 'required_items'
    };
    return aliases[key] || key;
  }

  function recognitionStateFromField(raw, value) {
    var explicit = raw.recognition_state || raw.recognitionState || raw.confidence_state || raw.state;
    if (RECOGNITION_LABELS[explicit]) return explicit;
    if (!stringValue(value).trim()) return RECOGNITION_STATES.NOT_FOUND;

    var confidenceText = raw.confidence == null ? '' : stringValue(raw.confidence).trim();
    var confidence = confidenceText === '' ? NaN : Number(confidenceText);

    if (Number.isFinite(confidence) && confidence >= 0 && confidence <= 1) {
      if (confidence >= 0.85) return RECOGNITION_STATES.CLEAR;
      if (confidence < 0.5) return RECOGNITION_STATES.UNCERTAIN;
    }
    return RECOGNITION_STATES.NEEDS_CONFIRMATION;
  }

  function normalizeField(raw, fallbackKey) {
    if (raw == null || typeof raw !== 'object') {
      var primitiveKey = canonicalNoticeFieldKey(fallbackKey);
      var primitiveValue = stringValue(raw);
      return createFieldModel(
        primitiveKey,
        primitiveValue,
        primitiveValue.trim() ? RECOGNITION_STATES.NEEDS_CONFIRMATION : RECOGNITION_STATES.NOT_FOUND,
        '',
        GUARDIAN_STATES.PENDING
      );
    }

    var key = canonicalNoticeFieldKey(raw.key || raw.name || raw.field || fallbackKey || '');
    var value = stringValue(raw.value == null ? raw.text : raw.value);
    var guardian = raw.guardian_state || raw.guardianState;

    return {
      key: key,
      label: stringValue(FIELD_LABELS[key] || raw.label || key),
      value: value,
      recognition_state: recognitionStateFromField(raw, value),
      guardian_state: GUARDIAN_LABELS[guardian] ? guardian : GUARDIAN_STATES.PENDING,
      source_excerpt: stringValue(raw.source_excerpt || raw.sourceExcerpt || raw.excerpt)
    };
  }

  function ensureReviewFields(fields) {
    var byKey = {};
    fields.forEach(function (field) {
      if (field.key && !byKey[field.key]) byKey[field.key] = field;
    });

    REQUIRED_REVIEW_FIELDS.forEach(function (key) {
      if (!byKey[key]) {
        var missing = createFieldModel(key, '', RECOGNITION_STATES.NOT_FOUND, '', GUARDIAN_STATES.PENDING);
        fields.push(missing);
        byKey[key] = missing;
      }
    });
    return fields;
  }

  function transportError(code, message, retryable, requestId) {
    var error = new Error(code || 'unknown_error');
    error.code = code || 'unknown_error';
    error.user_message = message || '';
    error.retryable = retryable !== false;
    error.request_id = requestId || '';
    return error;
  }

  function unwrapCanonicalResponse(response, preferredKeys, requireSuccess) {
    if (!response || typeof response !== 'object') {
      throw transportError('unknown_error', '服務沒有返回可驗證的結果。', true, '');
    }

    if (response.success === false) {
      var failure = response.error || {};
      throw transportError(
        failure.code || 'unknown_error',
        failure.message || '服務未能完成要求。',
        failure.retryable,
        response.request_id || response.requestId || ''
      );
    }

    if (requireSuccess && response.success !== true) {
      throw transportError('invalid_response', '服務回應缺少成功狀態，未建立任何完成記錄。', false, '');
    }

    var requestId = response.request_id || response.requestId || '';
    var payload = response.data || response.result || response;
    var keys = asArray(preferredKeys);

    for (var index = 0; index < keys.length; index += 1) {
      if (payload && typeof payload === 'object' && payload[keys[index]] != null) {
        payload = payload[keys[index]];
        break;
      }
      if (response[keys[index]] != null) {
        payload = response[keys[index]];
        break;
      }
    }

    if (!payload || typeof payload !== 'object') {
      throw transportError('invalid_response', '服務回應格式不完整。', false, requestId);
    }

    var normalized = Object.assign({}, payload);
    if (!normalized.request_id && requestId) normalized.request_id = requestId;
    return normalized;
  }

  function normalizeParseResponse(response) {
    var source = unwrapCanonicalResponse(response, ['notice', 'parsed_notice'], true);
    var requestId = source.request_id || response.request_id || response.requestId || '';
    var fieldSource = source.fields || source.notice_fields || source.ocr_fields || source.extracted_fields;
    var fields = [];

    if (Array.isArray(fieldSource)) {
      fields = fieldSource.map(function (field, index) {
        return normalizeField(field, 'field_' + index);
      });
    } else if (fieldSource && typeof fieldSource === 'object') {
      fields = Object.keys(fieldSource).map(function (key) {
        var raw = fieldSource[key];
        if (raw && typeof raw === 'object') return normalizeField(Object.assign({ key: key }, raw), key);
        return normalizeField({ key: key, value: raw }, key);
      });
    } else {
      Object.keys(FIELD_LABELS).forEach(function (key) {
        if (source[key] != null) {
          fields.push(normalizeField({
            key: key,
            value: source[key],
            recognition_state: source.recognition_state || source.recognitionState,
            source_excerpt: source.source_excerpt || source.raw_text
          }, key));
        }
      });
    }

    fields = ensureReviewFields(fields.filter(function (field) { return field.key; }));

    return {
      request_id: stringValue(requestId),
      recognition_state: RECOGNITION_LABELS[source.recognition_state || source.recognitionState]
        ? (source.recognition_state || source.recognitionState)
        : RECOGNITION_STATES.NEEDS_CONFIRMATION,
      fields: fields,
      raw_text: stringValue(source.raw_text || source.rawText || source.text),
      warnings: asArray(source.warnings)
    };
  }

  function normalizeItem(raw, fallbackId, group) {
    if (raw && typeof raw === 'object') {
      return {
        id: stringValue(raw.id || raw.key || fallbackId),
        name: stringValue(raw.name || raw.label || raw.item).trim(),
        note: stringValue(raw.note || raw.reason || raw.description),
        group: stringValue(raw.group || group || 'custom'),
        checked: !!raw.checked,
        removed: !!raw.removed
      };
    }

    return {
      id: stringValue(fallbackId),
      name: stringValue(raw).trim(),
      note: '',
      group: stringValue(group || 'custom'),
      checked: false,
      removed: false
    };
  }

  function normalizePackingResponse(response, existingRequestId) {
    var source = unwrapCanonicalResponse(response, ['packing_list', 'packingList'], true);
    var requestId = source.request_id || response.request_id || response.requestId || existingRequestId || '';

    function normalizeGroup(value, group) {
      return asArray(value).map(function (item, index) {
        return normalizeItem(item, group + '_' + index, group);
      }).filter(function (item) {
        return item.name && !item.removed;
      });
    }

    return {
      request_id: stringValue(requestId),
      required_items: normalizeGroup(source.required_items || source.requiredItems, 'required'),
      suggested_items: normalizeGroup(source.suggested_items || source.suggestedItems, 'suggested'),
      custom_items: normalizeGroup(source.custom_items || source.customItems, 'custom'),
      warnings: asArray(source.warnings)
    };
  }

  function bindWorkspace(root) {
    if (!root || workspaceBindings.has(root)) return;

    var requiredViews = ['review', 'packing', 'prep', 'confirm', 'records'];
    var missingViews = requiredViews.filter(function (view) {
      return !root.querySelector('[data-upload-view="' + view + '"]');
    });

    if (missingViews.length) {
      root.setAttribute('data-upload-runtime-error', 'missing_liquid_hosts');
      return;
    }

    root.setAttribute('data-upload-runtime-bound', VERSION);
    root.setAttribute(
      'data-transport-status',
      window.LittleGUploadTransport && window.LittleGUploadTransport.configured ? 'configured' : 'unconfigured'
    );

    var views = queryAll(root, '[data-upload-view]');
    var announcer = root.querySelector('[data-upload-announcer]');
    var fileNameNode = root.querySelector('[data-upload-file-name]');
    var fileSizeNode = root.querySelector('[data-upload-file-size]');
    var errorTitleNode = root.querySelector('[data-upload-error-title]');
    var errorMessageNode = root.querySelector('[data-upload-error-message]');
    var loadingView = root.querySelector('[data-upload-view="loading"]');
    var loadingKickerNode = root.querySelector('[data-upload-loading-kicker]');
    var loadingHeadingNode = root.querySelector('[data-upload-loading-heading]');
    var loadingMessageNode = root.querySelector('[data-upload-loading-message]');
    var loadingStepNodes = queryAll(root, '[data-upload-loading-step]');
    var reviewFieldsRoot = root.querySelector('[data-notice-review-fields]');
    var reviewFieldTemplate = root.querySelector('[data-notice-review-field-template]');
    var packingItemTemplate = root.querySelector('[data-packing-item-template]');
    var prepItemTemplate = root.querySelector('[data-prep-item-template]');
    var manualForm = root.querySelector('[data-upload-manual-form]');
    var manualItemInput = root.querySelector('[data-manual-item-input]');
    var manualItemList = root.querySelector('[data-manual-items]');
    var packingCustomInput = root.querySelector('[data-packing-custom-input]');
    var confirmCta = root.querySelector('[data-guardian-confirm-cta]');

    var selectedFile = null;
    var selectedSource = '';
    var reviewModel = null;
    var packingModel = null;
    var checklist = [];
    var manualItems = [];
    var requestController = null;
    var requestVersion = 0;
    var stateBeforeLoading = UI_STATES.EMPTY;
    var stateBeforeOffline = UI_STATES.EMPTY;
    var stateBeforeError = UI_STATES.EMPTY;
    var lastOperation = '';
    var lastSourceTrigger = null;
    var currentStep = 'u01';
    var cleanupTasks = [];
    var initialIntentTimer = 0;
    var destroyed = false;

    function listen(target, type, handler, options) {
      if (!target || typeof target.addEventListener !== 'function') return;
      var listenerOptions = options || false;
      var capture = listenerOptions === true || !!(listenerOptions && listenerOptions.capture);
      target.addEventListener(type, handler, listenerOptions);
      cleanupTasks.push(function () {
        target.removeEventListener(type, handler, capture);
      });
    }

    function abortActiveRequest() {
      if (requestController) requestController.abort();
      requestController = null;
    }

    function destroyBinding() {
      if (destroyed) return;
      destroyed = true;
      requestVersion += 1;
      abortActiveRequest();
      window.clearTimeout(initialIntentTimer);
      cleanupTasks.splice(0).reverse().forEach(function (cleanup) { cleanup(); });
      root.removeAttribute('data-upload-runtime-bound');
      workspaceBindings.delete(root);
    }

    function announce(message) {
      if (!announcer) return;
      announcer.textContent = '';
      window.requestAnimationFrame(function () {
        announcer.textContent = stringValue(message);
      });
    }

    function viewForState(state) {
      return root.querySelector('[data-upload-view="' + state + '"]');
    }

    function focusElement(element) {
      if (!element) return;
      window.requestAnimationFrame(function () {
        if (!document.documentElement.contains(element) || element.closest('[hidden]')) return;
        try {
          element.focus({ preventScroll: false });
        } catch (error) {
          element.focus();
        }
      });
    }

    function focusState(state, returnTarget) {
      if (returnTarget && document.documentElement.contains(returnTarget)) {
        focusElement(returnTarget);
        return;
      }

      var view = viewForState(state);
      if (!view) return;
      var selector = STATE_FOCUS_SELECTORS[state];
      var target = selector ? view.querySelector(selector) : null;
      if (!target) target = view.querySelector('.lgu-button--primary:not(:disabled), button:not(:disabled), input:not(:disabled), [tabindex]');
      focusElement(target);
    }

    function stepForState(state) {
      if (state === UI_STATES.LOADING || state === UI_STATES.ERROR || state === UI_STATES.OFFLINE) return currentStep;
      return STEP_BY_STATE[state] || currentStep;
    }

    function setState(nextState, message, options) {
      var settings = options || {};
      var targetView = viewForState(nextState);

      if (!targetView) {
        root.setAttribute('data-upload-runtime-error', 'missing_view_' + nextState);
        return;
      }

      currentStep = stepForState(nextState);
      root.setAttribute('data-upload-state', nextState);
      root.setAttribute('data-upload-active-step', currentStep);
      root.setAttribute('aria-busy', nextState === UI_STATES.LOADING ? 'true' : 'false');

      views.forEach(function (view) {
        view.hidden = view.getAttribute('data-upload-view') !== nextState;
      });

      if (message) announce(message);

      root.dispatchEvent(new CustomEvent('littleg:upload-state-change', {
        bubbles: true,
        detail: {
          state: nextState,
          step: currentStep,
          has_file: !!selectedFile,
          request_id: currentRequestId(),
          operation: lastOperation
        }
      }));

      if (settings.focus !== false) focusState(nextState, settings.returnFocus || null);
    }

    function renderLoadingOperation(operation) {
      var resolvedOperation = LOADING_OPERATIONS[operation] ? operation : 'parse';
      var config = LOADING_OPERATIONS[resolvedOperation];

      root.setAttribute('data-upload-loading-operation', resolvedOperation);
      if (loadingView) loadingView.setAttribute('data-loading-operation', resolvedOperation);
      if (loadingKickerNode) loadingKickerNode.textContent = config.kicker;
      if (loadingHeadingNode) loadingHeadingNode.textContent = config.title;
      if (loadingMessageNode) loadingMessageNode.textContent = config.message;

      loadingStepNodes.forEach(function (node, index) {
        var step = config.steps[index];
        if (!step) {
          node.hidden = true;
          return;
        }

        node.hidden = false;
        node.setAttribute('data-step-state', step.state);
        if (step.state === 'active') node.setAttribute('aria-current', 'step');
        else node.removeAttribute('aria-current');

        var titleNode = node.querySelector('[data-upload-loading-step-title]');
        var statusNode = node.querySelector('[data-upload-loading-step-status]');
        if (titleNode) titleNode.textContent = step.title;
        if (statusNode) statusNode.textContent = step.status;
      });

      return config;
    }

    function setLoading(operation, returnState) {
      stateBeforeLoading = returnState || root.getAttribute('data-upload-state') || UI_STATES.EMPTY;
      var config = renderLoadingOperation(operation);
      setState(UI_STATES.LOADING, config.announcement);
    }

    function showError(code, title, message, operation, returnState) {
      stateBeforeError = returnState || root.getAttribute('data-upload-state') || UI_STATES.EMPTY;
      if (stateBeforeError === UI_STATES.LOADING) stateBeforeError = stateBeforeLoading;
      lastOperation = operation || lastOperation;
      root.setAttribute('data-upload-error-code', stringValue(code || 'unknown_error'));
      root.setAttribute('data-upload-error-operation', stringValue(lastOperation));
      if (errorTitleNode) errorTitleNode.textContent = title || '暫時未能完成';
      if (errorMessageNode) errorMessageNode.textContent = message || '請稍後重試，或改為手動建立清單。';
      setState(UI_STATES.ERROR, title || '操作未完成');
    }

    function showTransportError(error, fallbackTitle, operation, returnState) {
      var code = stringValue(error && (error.code || error.message || error.status) || 'unknown_error').toLowerCase();
      var message = stringValue(error && (error.user_message || error.userMessage || error.detail));

      if (code === '401' || code === '403' || code === 'session_expired' || code === 'unauthorized') {
        showError('session_expired', '登入狀態已過期', message || '請重新登入後再提交。目前頁面資料仍保留。', operation, returnState);
        return;
      }
      if (code === '429' || code === 'rate_limited') {
        showError('rate_limited', '提交太頻密', message || '請稍後再試。你也可以先手動整理清單。', operation, returnState);
        return;
      }
      if (code === '503' || code === 'provider_unavailable' || code === 'provider_not_configured') {
        showError('provider_unavailable', '服務暫時不可用', message || '自動讀取或清單服務暫時未能回應，請稍後再試。', operation, returnState);
        return;
      }
      if (code === 'timeout' || code === 'provider_timeout' || code === 'gateway_timeout') {
        showError('timeout', '服務回應逾時', message || '服務回應時間較長，請稍後重試。', operation, returnState);
        return;
      }
      if (code === 'network_error' || code === 'network_unavailable' || code === 'fetch_failed') {
        showError('network_error', '網絡連線不穩定', message || '請檢查網絡後重試，或繼續使用本機清單。', operation, returnState);
        return;
      }
      if (code === 'offline') {
        stateBeforeOffline = returnState || UI_STATES.EMPTY;
        setState(UI_STATES.OFFLINE, '目前沒有網絡連線');
        return;
      }
      showError('unknown_error', fallbackTitle || '操作未完成', message || '沒有取得可驗證的結果。請重新嘗試或改為手動建立清單。', operation, returnState);
    }

    function currentRequestId() {
      return stringValue((packingModel && packingModel.request_id) || (reviewModel && reviewModel.request_id) || '');
    }

    function clearFileInputs() {
      queryAll(root, '[data-upload-input]').forEach(function (input) { input.value = ''; });
    }

    function updateFileSummary() {
      if (!selectedFile) return;
      if (fileNameNode) fileNameNode.textContent = selectedFile.name || '未命名檔案';
      if (fileSizeNode) fileSizeNode.textContent = formatBytes(selectedFile.size);
    }

    function resetFlow() {
      requestVersion += 1;
      if (requestController) requestController.abort();
      requestController = null;
      selectedFile = null;
      selectedSource = '';
      reviewModel = null;
      packingModel = null;
      checklist = [];
      manualItems = [];
      lastOperation = '';
      currentStep = 'u01';
       root.removeAttribute('data-confirm-resubmission-locked');
      root.removeAttribute('data-prep-celebrated');
      root.removeAttribute('data-record-persistence');
      root.removeAttribute('data-record-local-mirror');
      root.removeAttribute('data-record-id');
      root.removeAttribute('data-record-confirmed-at');
      var recordHost = root.querySelector('[data-packing-record]');
      if (recordHost) recordHost.setAttribute('data-record-status', 'not_saved');
      queryAll(root, '[data-manual-activity-name], [data-manual-activity-date], [data-manual-item-input], [data-packing-custom-input]').forEach(function (input) {
        input.value = '';
      });
      if (confirmCta) {
        confirmCta.disabled = true;
        confirmCta.setAttribute('aria-disabled', 'true');
      }
      clearFileInputs();
      renderManualItems();
      renderPacking();
      renderPrep();
      setState(UI_STATES.EMPTY, '可以上傳另一份通告', { returnFocus: lastSourceTrigger });
    }

    function removeFile() {
      selectedFile = null;
      selectedSource = '';
      reviewModel = null;
      packingModel = null;
      checklist = [];
      clearFileInputs();
      setState(UI_STATES.EMPTY, '已移除檔案', { returnFocus: lastSourceTrigger });
    }

    function selectFile(file, source) {
      if (!file) return;
      var validation = validateFile(file, source);

      if (!validation.ok) {
        selectedFile = null;
        selectedSource = source || '';
        showError(validation.code, validation.title, validation.message, '', UI_STATES.EMPTY);
        return;
      }

      selectedFile = file;
      selectedSource = source || 'unknown';
      reviewModel = null;
      packingModel = null;
      checklist = [];
      updateFileSummary();
      setState(UI_STATES.FILE_SELECTED, '已選擇 ' + (file.name || '通告檔案'));
    }

    function sourceInput(source) {
      return root.querySelector('[data-upload-input="' + source + '"]');
    }

    function openSource(source, trigger) {
      var input = sourceInput(source);
      if (trigger) lastSourceTrigger = trigger;
      if (!input) {
        showError('source_unavailable', '此上傳方式暫時不可用', '請改用其他方式或手動建立清單。', '', UI_STATES.EMPTY);
        return;
      }
      input.click();
    }

    function cancelRequest() {
      requestVersion += 1;
      if (requestController) requestController.abort();
      requestController = null;
      setState(stateBeforeLoading || UI_STATES.EMPTY, '已取消處理');
    }

    function renderReview() {
      if (!reviewFieldsRoot || !reviewFieldTemplate) return;
      reviewFieldsRoot.textContent = '';

      if (!reviewModel || !reviewModel.fields.length) {
        var empty = document.createElement('p');
        empty.setAttribute('data-notice-review-empty', '');
        empty.textContent = '尚未取得可驗證的通告欄位。';
        reviewFieldsRoot.appendChild(empty);
        return;
      }

      reviewModel.fields.forEach(function (field, index) {
        var fragment = reviewFieldTemplate.content.cloneNode(true);
        var row = fragment.querySelector('[data-notice-field]');
        var label = fragment.querySelector('[data-field-label]');
        var input = fragment.querySelector('[data-field-value]');
        var recognitionLabel = fragment.querySelector('[data-recognition-label]');
        var guardianLabel = fragment.querySelector('[data-guardian-label]');
        var excerpt = fragment.querySelector('[data-source-excerpt]');

        row.setAttribute('data-field-index', String(index));
        row.setAttribute('data-field-key', field.key);
        row.setAttribute('data-recognition-state', field.recognition_state);
        row.setAttribute('data-guardian-state', field.guardian_state);
        label.textContent = field.label || field.key;
        input.value = field.value;
        input.setAttribute('data-field-index', String(index));
        input.setAttribute('aria-label', '編輯' + (field.label || field.key));
        recognitionLabel.textContent = RECOGNITION_LABELS[field.recognition_state] || RECOGNITION_LABELS.not_found;
        guardianLabel.textContent = GUARDIAN_LABELS[field.guardian_state] || GUARDIAN_LABELS.pending;

        if (field.source_excerpt) {
          excerpt.hidden = false;
          excerpt.textContent = field.source_excerpt;
        }
        if (field.guardian_state === GUARDIAN_STATES.REMOVED) {
          input.disabled = true;
          row.setAttribute('aria-disabled', 'true');
        }
        reviewFieldsRoot.appendChild(fragment);
      });
    }

    function updateGuardianBadge(row, state) {
      if (!row) return;
      row.setAttribute('data-guardian-state', state);
      var badge = row.querySelector('[data-guardian-label]');
      if (badge) badge.textContent = GUARDIAN_LABELS[state] || state;
    }

    function collectReviewModel(confirmPending) {
      if (!reviewModel) return null;

      queryAll(root, '[data-notice-field]').forEach(function (row) {
        var index = Number(row.getAttribute('data-field-index'));
        var field = reviewModel.fields[index];
        var input = row.querySelector('[data-field-value]');
        if (!field || !input) return;

        if (field.guardian_state !== GUARDIAN_STATES.REMOVED) {
          var nextValue = stringValue(input.value).trim();
          if (nextValue !== field.value) {
            field.value = nextValue;
            field.guardian_state = GUARDIAN_STATES.MANUALLY_EDITED;
          } else if (confirmPending && field.guardian_state === GUARDIAN_STATES.PENDING) {
            field.guardian_state = GUARDIAN_STATES.CONFIRMED;
          }
        }
        updateGuardianBadge(row, field.guardian_state);
      });
      return reviewModel;
    }

    async function parseSelectedFile() {
      if (!selectedFile) {
        setState(UI_STATES.EMPTY, '請先選擇通告檔案', { returnFocus: lastSourceTrigger });
        return;
      }

      lastOperation = 'parse';
      requestVersion += 1;
      var thisRequest = requestVersion;
      if (requestController) requestController.abort();
      requestController = typeof AbortController === 'function' ? new AbortController() : null;
      setLoading('parse', UI_STATES.FILE_SELECTED);

      try {
        var response = await window.LittleGUploadTransport.parseNotice({
          file: selectedFile,
          source: selectedSource,
          signal: requestController ? requestController.signal : null
        });
        if (thisRequest !== requestVersion) return;
        reviewModel = normalizeParseResponse(response);
        renderReview();
        setState(UI_STATES.REVIEW, '請家長逐欄確認通告內容');
      } catch (error) {
        if (thisRequest !== requestVersion) return;
        if (error && error.name === 'AbortError') {
          setState(UI_STATES.FILE_SELECTED, '已取消讀取');
          return;
        }
        showTransportError(error, '通告讀取未完成', 'parse', UI_STATES.FILE_SELECTED);
      } finally {
        if (thisRequest === requestVersion) requestController = null;
      }
    }

    function serializeReviewModel() {
      var model = collectReviewModel(true);
      if (!model) return null;
      return {
        request_id: model.request_id,
        recognition_state: model.recognition_state,
        raw_text: model.raw_text,
        fields: model.fields.map(function (field) {
          return {
            key: field.key,
            label: field.label,
            value: field.value,
            recognition_state: field.recognition_state,
            guardian_state: field.guardian_state,
            source_excerpt: field.source_excerpt
          };
        })
      };
    }

    function activePackingItems(group) {
      if (!packingModel) return [];
      return asArray(packingModel[group + '_items']).filter(function (item) {
        return item && item.name && !item.removed;
      });
    }

    function renderPackingGroup(group) {
      var target = root.querySelector('[data-packing-items="' + group + '"]');
      if (!target || !packingItemTemplate) return;
      target.textContent = '';

      var items = activePackingItems(group);
      if (!items.length) {
        var empty = document.createElement('li');
        empty.className = 'lgu-empty-note';
        empty.textContent = '暫無項目';
        target.appendChild(empty);
        return;
      }

      items.forEach(function (item) {
        var fragment = packingItemTemplate.content.cloneNode(true);
        var row = fragment.querySelector('[data-packing-item]');
        var label = fragment.querySelector('[data-packing-item-label]');
        var note = fragment.querySelector('[data-packing-item-note]');
        var remove = fragment.querySelector('[data-upload-action="remove-packing-item"]');
        row.setAttribute('data-packing-item-id', item.id);
        row.setAttribute('data-packing-item-source', group);
        label.textContent = item.name;
        remove.setAttribute('aria-label', '移除 ' + item.name);
        if (note && item.note) {
          note.hidden = false;
          note.textContent = item.note;
        }
        target.appendChild(fragment);
      });
    }

     function renderPacking() {
      ['required', 'suggested', 'custom'].forEach(renderPackingGroup);

      var context = root.querySelector('[data-packing-context]');
      if (context) {
        var activityDate = reviewFieldValue('activity_date');
        context.textContent = activityDate
          ? '活動日期：' + activityDate
          : '活動日期尚未填寫，可返回通告內容補充。';
      }
    }

    function addPackingCustomItem(value) {
      var name = stringValue(value).trim();
      if (!name) return false;
      if (!packingModel) {
        packingModel = { request_id: currentRequestId(), required_items: [], suggested_items: [], custom_items: [], warnings: [] };
      }
      packingModel.custom_items.push(normalizeItem(
        { name: name, group: 'custom' },
        'custom_' + packingModel.custom_items.length,
        'custom'
      ));
      renderPacking();
      return true;
    }

    function removePackingItem(row) {
      if (!row || !packingModel) return;
      var group = row.getAttribute('data-packing-item-source');
      var id = row.getAttribute('data-packing-item-id');
      var list = packingModel[group + '_items'];
      if (!Array.isArray(list)) return;
      list.forEach(function (item) { if (item.id === id) item.removed = true; });
      renderPacking();
      announce('已從清單移除物品');
    }

    async function generatePackingList() {
      var notice = serializeReviewModel();
      if (!notice) {
        showError('missing_review_model', '尚未有可確認資料', '請先完成通告讀取或改為手動建立清單。', 'generate', UI_STATES.REVIEW);
        return;
      }

      var activeFields = notice.fields.filter(function (field) {
        return field.guardian_state !== GUARDIAN_STATES.REMOVED;
      });
      if (!activeFields.length) {
        showError('empty_review', '所有通告欄位均已移除', '請保留或新增至少一個欄位後再生成清單。', 'generate', UI_STATES.REVIEW);
        return;
      }
      lastOperation = 'generate';
      requestVersion += 1;
      var thisRequest = requestVersion;
      if (requestController) requestController.abort();
      requestController = typeof AbortController === 'function' ? new AbortController() : null;
      setLoading('generate', UI_STATES.REVIEW);

      try {
        var response = await window.LittleGUploadTransport.generatePackingList({
          request_id: notice.request_id,
          notice: notice,
          signal: requestController ? requestController.signal : null
        });
        if (thisRequest !== requestVersion) return;
        packingModel = normalizePackingResponse(response, notice.request_id);
        renderPacking();
        buildChecklist();
        setState(UI_STATES.PACKING, '今日清單已准备好');
      } catch (error) {
        if (thisRequest !== requestVersion) return;
        if (error && error.name === 'AbortError') {
          setState(UI_STATES.REVIEW, '已取消生成清單');
          return;
        }
        showTransportError(error, '清單生成未完成', 'generate', UI_STATES.REVIEW);
      } finally {
        if (thisRequest === requestVersion) requestController = null;
      }
    }

    function buildChecklist() {
      if (!packingModel) {
        checklist = [];
        renderPrep();
        return;
      }
      checklist = []
        .concat(activePackingItems('required'))
        .concat(activePackingItems('suggested'))
        .concat(activePackingItems('custom'))
        .map(function (item, index) {
          return {
            id: item.id || 'check_' + index,
            name: item.name,
            note: item.note || '',
            group: item.group || 'custom',
            checked: !!item.checked
          };
        });
      renderPrep();
    }

    function renderPrep() {
      var target = root.querySelector('[data-prep-checklist]');
      if (!target || !prepItemTemplate) return;
      target.textContent = '';

      if (!checklist.length) {
        var empty = document.createElement('li');
        empty.className = 'lgu-empty-note';
        empty.textContent = '目前沒有需要核對的物品。';
        target.appendChild(empty);
        updatePrepProgress();
        return;
      }

      checklist.forEach(function (item, index) {
        var fragment = prepItemTemplate.content.cloneNode(true);
        var row = fragment.querySelector('[data-prep-item]');
        var checkbox = fragment.querySelector('[data-prep-item-toggle]');
       var label = fragment.querySelector('[data-prep-item-label]');
        var groupLabel = fragment.querySelector('[data-prep-item-group]');
        var note = fragment.querySelector('[data-prep-item-note]');
        row.setAttribute('data-prep-index', String(index));
        row.setAttribute('data-prep-group', item.group);
        checkbox.setAttribute('data-prep-index', String(index));
        checkbox.checked = !!item.checked;
        checkbox.setAttribute('aria-label', '已準備 ' + item.name);
        label.textContent = item.name;
        if (groupLabel) groupLabel.textContent = PACKING_GROUP_LABELS[item.group] || '家長新增';
        if (note && item.note) {
          note.hidden = false;
          note.textContent = item.note;
        }
        target.appendChild(fragment);
      });
      updatePrepProgress();
    }

   function updatePrepProgress() {
      var shell = root.querySelector('[data-prep-progress-shell]');
      var progress = root.querySelector('[data-prep-progress]');
      var count = root.querySelector('[data-prep-progress-count]');
      var percentNode = root.querySelector('[data-prep-progress-percent]');
      var status = root.querySelector('[data-prep-progress-status]');
      var celebration = root.querySelector('[data-prep-celebration]');
      var total = checklist.length;
      var checked = checklist.filter(function (item) { return item.checked; }).length;
      var percent = total ? Math.round((checked / total) * 100) : 0;
      var complete = total > 0 && checked === total;
      var firstCompletion = complete && root.getAttribute('data-prep-celebrated') !== 'true';

      if (shell) {
        shell.setAttribute('data-prepared', String(checked));
        shell.setAttribute('data-total', String(total));
        shell.setAttribute('data-complete', complete ? 'true' : 'false');
      }
      if (progress) {
        progress.max = total || 1;
        progress.value = checked;
        progress.textContent = checked + '／' + total;
      }
      if (count) count.textContent = '已準備 ' + checked + '／' + total + ' 項';
      if (percentNode) percentNode.textContent = percent + '%';
      if (status) {
        if (!total) status.textContent = '尚未開始。';
        else if (complete) status.textContent = '所有物品已準備完成。';
        else status.textContent = '尚有 ' + (total - checked) + ' 項未完成。';
      }
      if (celebration) celebration.hidden = !firstCompletion;
      if (firstCompletion) root.setAttribute('data-prep-celebrated', 'true');
    }

    function reviewFieldValue(key) {
      if (!reviewModel) return '';
      var field = reviewModel.fields.find(function (candidate) {
        return candidate.key === key && candidate.guardian_state !== GUARDIAN_STATES.REMOVED;
      });
      return field ? field.value : '';
    }

    function renderConfirmSummary() {
      var total = checklist.length;
      var checked = checklist.filter(function (item) { return item.checked; }).length;
      var unchecked = checklist.filter(function (item) { return !item.checked; });
      var hasNoItems = total === 0;
      var hasIncompleteItems = unchecked.length > 0;
      var isComplete = !hasNoItems && !hasIncompleteItems;
      var confirmationBlocked = !isComplete;
      var values = {
        '[data-confirm-activity-name]': reviewFieldValue('activity_name'),
        '[data-confirm-activity-date]': reviewFieldValue('activity_date'),
        '[data-confirm-item-count]': total,
        '[data-confirm-checked-count]': checked,
        '[data-confirm-incomplete-count]': unchecked.length
      };

      Object.keys(values).forEach(function (selector) {
        var node = root.querySelector(selector);
        if (node) node.textContent = values[selector] === '' ? '—' : stringValue(values[selector]);
      });

      var confirmView = root.querySelector('[data-upload-view="confirm"]');
      if (confirmView) confirmView.setAttribute('data-confirm-completion-state', isComplete ? 'complete' : 'incomplete');

      var successPanel = root.querySelector('[data-confirm-success]');
      if (successPanel) successPanel.hidden = !isComplete;

      var uncheckedSection = root.querySelector('.lgu-confirm-unchecked');
      if (uncheckedSection) uncheckedSection.hidden = isComplete;

      var uncheckedList = root.querySelector('[data-confirm-unchecked-items]');
      if (uncheckedList) {
        uncheckedList.textContent = '';
        unchecked.forEach(function (item) {
          var row = document.createElement('li');
          row.textContent = item.name;
          uncheckedList.appendChild(row);
        });
      }

      var status = root.querySelector('[data-confirm-status]');
      if (status) {
        if (hasNoItems) status.textContent = '清單目前沒有任何項目。請返回清單頁加入至少一件物品。';
        else if (hasIncompleteItems) status.textContent = '仍有 ' + unchecked.length + ' 項未勾選。請完成準備後再確認保存。';
        else status.textContent = '所有項目已勾選，可以由家長最終確認。';
      }

      if (confirmCta) {
        confirmCta.disabled = confirmationBlocked;
        confirmCta.setAttribute('aria-disabled', confirmationBlocked ? 'true' : 'false');
      }
    }

    function renderRecord(response) {
      var source = unwrapCanonicalResponse(response, ['record', 'confirmation'], true);
      var requestId = source.request_id || response.request_id || response.requestId || currentRequestId();

      if (!requestId) {
        throw transportError('invalid_response', '確認成功回應缺少 request_id，未建立完成記錄。', false, '');
      }

      var nestedRecord = source.record && typeof source.record === 'object' && !Array.isArray(source.record) ? source.record : {};
      var recordId = source.record_id || source.result_id || nestedRecord.record_id || nestedRecord.result_id || nestedRecord.id || requestId;
      var persistence = source.persistence || nestedRecord.persistence || 'backend_confirmed';
      var isLocalOnly = persistence === 'local_only';
      var localMirrorSaved = isLocalOnly || source.local_mirror_saved === true || nestedRecord.local_mirror_saved === true;
   var confirmedAt = source.confirmed_at || source.confirmedAt || nestedRecord.confirmed_at || nestedRecord.confirmedAt || '—';
      var confirmedAtLabel = formatHongKongDateTime(confirmedAt);      root.setAttribute('data-record-persistence', isLocalOnly ? 'local_only' : 'backend_confirmed');
      root.setAttribute('data-record-local-mirror', localMirrorSaved ? 'saved' : 'failed');
      root.setAttribute('data-record-id', stringValue(recordId));
      root.setAttribute('data-record-confirmed-at', confirmedAt === '—' ? '' : stringValue(confirmedAt));
      root.setAttribute('data-confirm-resubmission-locked', 'true');

      if (confirmCta) {
        confirmCta.disabled = true;
        confirmCta.setAttribute('aria-disabled', 'true');
      }

      var recordHost = root.querySelector('[data-packing-record]');
      if (recordHost) {
        recordHost.setAttribute(
          'data-record-status',
          isLocalOnly ? 'local_saved' : (localMirrorSaved ? 'saved' : 'backend_saved_local_mirror_failed')
        );
      }

      var statusLabel = isLocalOnly ? '已私人保存' : (source.status === 'confirmed' ? '已確認保存' : source.status || '已確認保存');
      var values = {
        '[data-record-id]': recordId,
        '[data-record-status-label]': statusLabel,
        '[data-record-confirmed-at]': confirmedAtLabel,


        '[data-record-activity-name]': reviewFieldValue('activity_name') || '—'
      };

      Object.keys(values).forEach(function (selector) {
        var node = root.querySelector(selector);
        if (node) node.textContent = stringValue(values[selector]);
      });

      var list = root.querySelector('[data-record-items]');
      if (list) {
        list.textContent = '';
        checklist.forEach(function (item) {
          var row = document.createElement('li');
          row.textContent = (item.checked ? '已準備：' : '未勾選：') + item.name;
          row.setAttribute('data-record-item-status', item.checked ? 'checked' : 'unchecked');
          list.appendChild(row);
        });
      }

      var saveStatus = root.querySelector('[data-record-save-status]');
      if (saveStatus) {
        if (isLocalOnly) saveStatus.textContent = '已私人保存於此裝置；尚未同步後端。';
        else if (!localMirrorSaved) saveStatus.textContent = '後端已確認保存，但此裝置的私人記錄暫未建立。請保留此頁的記錄編號，毋須再次提交。';
        else saveStatus.textContent = '後端已確認保存，並已加入此裝置的私人記錄。';
      }
    }

    function handleConfirmationRecovery(event) {
      var draft = event && event.detail && event.detail.draft;
      if (!draft || draft.confirmation_recovery_required !== true) return;

      requestVersion += 1;
      abortActiveRequest();

      var requestId = stringValue(draft.request_id || draft.backend_record_id).trim();
      var recordId = stringValue(draft.backend_record_id || requestId).trim();
      var reviewFields = asArray(draft.review_fields).map(function (field, index) {
        return normalizeField(field, 'field_' + index);
      });
      reviewModel = {
        request_id: requestId,
        recognition_state: RECOGNITION_STATES.NEEDS_CONFIRMATION,
        fields: ensureReviewFields(reviewFields),
        raw_text: '',
        warnings: ['confirmation_recovery']
      };

      var recoveryItems = asArray(draft.packing_items).map(function (item, index) {
        var group = stringValue(item && item.group || 'custom');
        return normalizeItem(item, 'recovery_' + index, group);
      });
      packingModel = {
        request_id: requestId,
        required_items: recoveryItems.filter(function (item) { return item.group === 'required'; }),
        suggested_items: recoveryItems.filter(function (item) { return item.group === 'suggested'; }),
        custom_items: recoveryItems.filter(function (item) { return item.group !== 'required' && item.group !== 'suggested'; }),
        warnings: ['confirmation_recovery']
      };
      checklist = asArray(draft.checklist).map(function (item, index) {
        return {
          id: stringValue(item && item.id || 'recovery_check_' + index),
          name: stringValue(item && item.name),
          note: stringValue(item && item.note),
          group: stringValue(item && item.group || 'custom'),
          checked: !!(item && item.checked)
        };
      }).filter(function (item) { return item.name; });
      if (!checklist.length) {
        checklist = recoveryItems.map(function (item) {
          return { id: item.id, name: item.name, note: item.note, group: item.group, checked: !!item.checked };
        });
      }

      renderRecord({
        success: true,
        request_id: requestId || recordId,
        data: {
          confirmation: {
            request_id: requestId || recordId,
            record_id: recordId || requestId,
            status: 'confirmed',
            confirmed_at: stringValue(draft.backend_confirmed_at),
            persistence: 'backend_confirmed',
            local_mirror_saved: false
          }
        }
      });
      setState(UI_STATES.RECORDS, '後端已確認保存，毋須再次提交');
    }

    async function confirmNotice() {
      if (root.getAttribute('data-confirm-resubmission-locked') === 'true') {
        announce('這次記錄已確認保存，毋須再次提交');
        if (confirmCta) {
          confirmCta.disabled = true;
          confirmCta.setAttribute('aria-disabled', 'true');
        }
        return;
      }

      var confirmationSucceeded = false;
      if (!reviewModel || !packingModel) {
        showError('missing_confirmation_model', '確認資料不完整', '請返回通告或清單頁面重新整理。', 'confirm', UI_STATES.CONFIRM);
        return;
      }
      if (!checklist.length) {
        renderConfirmSummary();
        announce('清單目前沒有任何項目');
        focusElement(root.querySelector('[data-confirm-status]'));
        return;
      }

      var incompleteItems = checklist.filter(function (item) { return !item.checked; });
      if (incompleteItems.length) {
        renderConfirmSummary();
        announce('仍有 ' + incompleteItems.length + ' 項未完成');
        focusElement(root.querySelector('[data-confirm-status]'));
        return;
      }

      lastOperation = 'confirm';
      requestVersion += 1;
      var thisRequest = requestVersion;
      if (requestController) requestController.abort();
      requestController = typeof AbortController === 'function' ? new AbortController() : null;
      if (confirmCta) confirmCta.disabled = true;
      setLoading('confirm', UI_STATES.CONFIRM);

      try {
        var response = await window.LittleGUploadTransport.confirmNotice({
          request_id: currentRequestId(),
          notice: serializeReviewModel(),
          packing_list: packingModel,
          checklist: checklist.map(function (item) {
            return { id: item.id, name: item.name, note: item.note, group: item.group, checked: !!item.checked };
          }),
          signal: requestController ? requestController.signal : null
        });

        if (thisRequest !== requestVersion) return;
        confirmationSucceeded = true;
        root.setAttribute('data-confirm-resubmission-locked', 'true');
        if (confirmCta) {
          confirmCta.disabled = true;
          confirmCta.setAttribute('aria-disabled', 'true');
        }
        renderRecord(response);
        setState(UI_STATES.RECORDS, '帶齊記錄已保存');
      } catch (error) {
        if (thisRequest !== requestVersion) return;
        if (confirmationSucceeded) {
          root.setAttribute('data-confirm-resubmission-locked', 'true');
          if (confirmCta) {
            confirmCta.disabled = true;
            confirmCta.setAttribute('aria-disabled', 'true');
          }
          setState(UI_STATES.CONFIRM, '後端已確認保存，請勿再次提交');
          announce('後端已確認保存，但完成畫面未能完整顯示。請勿再次提交。');
          return;
        }
        if (error && error.name === 'AbortError') {
          setState(UI_STATES.CONFIRM, '已取消確認');
          return;
        }
        showTransportError(error, '確認提交未完成', 'confirm', UI_STATES.CONFIRM);
      } finally {
        if (thisRequest === requestVersion) requestController = null;
        if (confirmCta) {
          var resubmissionLocked = confirmationSucceeded || root.getAttribute('data-confirm-resubmission-locked') === 'true';
          var confirmationBlocked = resubmissionLocked || checklist.length === 0 || checklist.some(function (item) { return !item.checked; });
          confirmCta.disabled = confirmationBlocked;
          confirmCta.setAttribute('aria-disabled', confirmationBlocked ? 'true' : 'false');
        }
      }
    }

    function renderManualItems() {
      if (!manualItemList) return;
      manualItemList.textContent = '';
      manualItems.forEach(function (item, index) {
        var row = document.createElement('li');
        var label = document.createElement('span');
        var remove = document.createElement('button');
        label.textContent = item;
        remove.type = 'button';
        remove.textContent = '移除';
        remove.setAttribute('aria-label', '移除 ' + item);
        remove.setAttribute('data-manual-remove-index', String(index));
        row.appendChild(label);
        row.appendChild(remove);
        manualItemList.appendChild(row);
      });
    }

    function addManualItem() {
      if (!manualItemInput) return;
      var value = stringValue(manualItemInput.value).trim();
      if (!value) {
        announce('請輸入應帶物品');
        focusElement(manualItemInput);
        return;
      }
      manualItems.push(value);
      manualItemInput.value = '';
      renderManualItems();
      announce('已加入 ' + value);
      focusElement(manualItemInput);
    }

    function promoteManualToPacking() {
      var activityName = root.querySelector('[data-manual-activity-name]');
      var activityDate = root.querySelector('[data-manual-activity-date]');
      var nameValue = stringValue(activityName && activityName.value).trim();
      var dateValue = stringValue(activityDate && activityDate.value).trim();

      if (!nameValue && !dateValue && !manualItems.length) {
        announce('請先輸入活動資料或至少一件應帶物品');
        focusElement(activityName || manualItemInput);
        return;
      }

      reviewModel = {
        request_id: '',
        recognition_state: RECOGNITION_STATES.NEEDS_CONFIRMATION,
        raw_text: '',
        fields: ensureReviewFields([
          createFieldModel('activity_name', nameValue, nameValue ? RECOGNITION_STATES.NEEDS_CONFIRMATION : RECOGNITION_STATES.NOT_FOUND, '', GUARDIAN_STATES.MANUALLY_EDITED),
          createFieldModel('activity_date', dateValue, dateValue ? RECOGNITION_STATES.NEEDS_CONFIRMATION : RECOGNITION_STATES.NOT_FOUND, '', GUARDIAN_STATES.MANUALLY_EDITED)
        ]),
        warnings: ['manual_mode']
      };

      packingModel = {
        request_id: '',
        required_items: [],
        suggested_items: [],
        custom_items: manualItems.map(function (name, index) {
          return normalizeItem({ name: name, group: 'custom' }, 'manual_' + index, 'custom');
        }),
        warnings: ['manual_mode']
      };

      renderPacking();
      buildChecklist();
      setState(UI_STATES.PACKING, '手動清單已建立');
    }

    function retryLastOperation() {
      if (lastOperation === 'parse') return parseSelectedFile();
      if (lastOperation === 'generate') return generatePackingList();
      if (lastOperation === 'confirm') return confirmNotice();
      setState(stateBeforeError || (selectedFile ? UI_STATES.FILE_SELECTED : UI_STATES.EMPTY), '返回上一個步驟');
    }

    function setOfflineStatus(offline) {
      root.setAttribute('data-network-state', offline ? 'offline' : 'online');
    }

    function handleOffline() {
      var current = root.getAttribute('data-upload-state') || UI_STATES.EMPTY;
      setOfflineStatus(true);

      if (current === UI_STATES.LOADING && (lastOperation === 'generate' || lastOperation === 'confirm')) {
        announce('網絡已中斷，正在切換至本機處理');
        return;
      }

      if ([UI_STATES.REVIEW, UI_STATES.PACKING, UI_STATES.PREP, UI_STATES.CONFIRM, UI_STATES.MANUAL].indexOf(current) !== -1) {
        announce('網絡已中斷；可繼續使用本機清單。自動讀取需恢復網絡。');
        return;
      }

      if (current === UI_STATES.LOADING) current = stateBeforeLoading;
      if (current !== UI_STATES.OFFLINE) stateBeforeOffline = current;
      requestVersion += 1;
      abortActiveRequest();
      setState(UI_STATES.OFFLINE, '目前沒有網絡連線');
    }

    function handleOnline() {
      setOfflineStatus(false);
      var current = root.getAttribute('data-upload-state') || UI_STATES.EMPTY;
      if (current !== UI_STATES.OFFLINE) {
        announce('網絡連線已恢復');
        return;
      }
      var fallback = selectedFile ? UI_STATES.FILE_SELECTED : UI_STATES.EMPTY;
      var next = viewForState(stateBeforeOffline) ? stateBeforeOffline : fallback;
      setState(next, '網絡連線已恢復', { returnFocus: next === UI_STATES.EMPTY ? lastSourceTrigger : null });
    }

    function uploadRouteParams() {
      try {
        return new URL(window.location.href).searchParams;
      } catch (_) {
        return new URLSearchParams();
      }
    }

    function uploadRouteIntent() {
      return stringValue(uploadRouteParams().get('intent')).trim().toLowerCase();
    }

    function uploadRouteRecordId() {
      var params = uploadRouteParams();
      return stringValue(params.get('record_id') || params.get('result_id')).trim();
    }

    function sourceButton(source) {
      return root.querySelector('[data-upload-source="' + source + '"]');
    }

    function recommendSource(source, message) {
      var button = sourceButton(source) || root.querySelector('[data-upload-source]');
      if (!button) return;
      button.setAttribute('data-upload-source-recommended', 'true');
      focusElement(button);
      if (message) announce(message);
    }

    function recordIdentity(record) {
      return stringValue(record && (record.record_id || record.result_id || record.card_id || record.id)).trim();
    }

    function familyRecordById(recordId) {
      var owner = window.LittleGFamilyData;
      if (!owner || typeof owner.listRecords !== 'function') return null;
      try {
        return owner.listRecords().find(function (record) {
          return recordIdentity(record) === recordId;
        }) || null;
      } catch (_) {
        return null;
      }
    }

    function reusablePackingItems(record) {
      var packing = record && record.packing_list && typeof record.packing_list === 'object' ? record.packing_list : {};
      var items = [];

      ['required', 'suggested', 'custom'].forEach(function (group) {
        var groupItems = packing[group + '_items'];
        if (!Array.isArray(groupItems)) return;
        groupItems.forEach(function (item, index) {
          items.push({
            id: stringValue(item && item.id).trim() || 'reuse_' + group + '_' + index,
            name: stringValue(item && (item.name || item.label || item.text)).trim(),
            note: stringValue(item && item.note).trim(),
            group: group,
            checked: false,
            removed: false
          });
        });
      });
      return items.filter(function (item) { return item.name; });
    }

    function reusableReviewFields(record) {
      var notice = record && record.notice && typeof record.notice === 'object' ? record.notice : {};
      var fields = Array.isArray(notice.fields) ? notice.fields : [];
      return fields.map(function (field, index) {
        var key = stringValue(field && (field.key || field.name)).trim() || 'field_' + index;
        var value = stringValue(field && (field.value || field.text)).trim();
        return createFieldModel(
          key,
          value,
          value ? RECOGNITION_STATES.NEEDS_CONFIRMATION : RECOGNITION_STATES.NOT_FOUND,
          stringValue(field && field.label).trim(),
          GUARDIAN_STATES.MANUALLY_EDITED
        );
      });
    }

    function reuseDraftFromRecord(record) {
      var notice = record.notice && typeof record.notice === 'object' ? record.notice : {};
      var packingItems = reusablePackingItems(record);
      return {
        schema: 'littleg_action_draft_v2',
        state: 'packing',
        step: 'u03',
        reuse_source_record_id: recordIdentity(record),
        reused_at: new Date().toISOString(),
        child: notice.child || record.child || null,
        review_fields: reusableReviewFields(record),
        deadlines: Array.isArray(notice.deadlines) ? notice.deadlines : [],
        packing_items: packingItems,
        checklist: packingItems.map(function (item) {
          return { id: item.id, name: item.name, note: item.note, group: item.group, checked: false };
        }),
        manual_items: [],
        action: null
      };
    }

    function activateRestoreControl() {
      var control = root.querySelector('[data-upload-action="recent"],[data-upload-action="restore-draft"]');
      if (!control) return false;
      control.hidden = false;
      control.disabled = false;
      control.setAttribute('aria-disabled', 'false');
      control.setAttribute('data-upload-action', 'restore-draft');
      control.click();
      return true;
    }

    function reuseRecord(recordId) {
      var record = familyRecordById(recordId);
      if (!record) {
        setState(UI_STATES.EMPTY, '找不到可再次使用的家庭記錄');
        recommendSource('library', '找不到該記錄，請重新選擇通告');
        return;
      }

      var owner = window.LittleGFamilyData;
      if (!owner || typeof owner.saveNoticeDraft !== 'function') {
        showError('family_data_unavailable', '未能建立新清單', '家庭資料暫時不可用，請重新載入。', 'reuse', UI_STATES.EMPTY);
        return;
      }

      var saved = owner.saveNoticeDraft(reuseDraftFromRecord(record));
      if (!saved || !activateRestoreControl()) {
        showError('reuse_restore_failed', '未能載入舊記錄', '舊記錄沒有被修改，請稍後再試。', 'reuse', UI_STATES.EMPTY);
        return;
      }
      announce('已使用舊記錄建立新清單，所有準備項目均已重設');
    }

    function applyInitialIntent() {
      if (!window.navigator.onLine) return;
      var intent = uploadRouteIntent();
      var recordId = uploadRouteRecordId();

      if (intent === 'reuse') {
        if (recordId) reuseRecord(recordId);
        else announce('缺少要再次使用的記錄編號');
        return;
      }
      if (intent === 'manual') {
        setState(UI_STATES.MANUAL, '已切換至手動建立清單');
        focusElement(root.querySelector('[data-manual-activity-name]'));
        return;
      }
      if (intent === 'resume' || intent === 'resume-notice') {
        var owner = window.LittleGFamilyData;
        var draft = owner && typeof owner.getNoticeDraft === 'function' ? owner.getNoticeDraft() : null;
        if (draft && activateRestoreControl()) return;
        setState(UI_STATES.EMPTY, '目前沒有可繼續的清單');
        recommendSource('camera', '目前沒有未完成清單，請建立新通告');
        return;
      }
      if (intent === 'camera' || intent === 'library' || intent === 'pdf') {
        recommendSource(intent, '請再次點擊以選擇來源');
        return;
      }
      if (intent === 'notice-start' || intent === 'new-notice' || intent === 'upload') {
        recommendSource('camera', '選擇拍攝、相簿或 PDF 開始');
      }
    }

    queryAll(root, '[data-upload-source]').forEach(function (button) {
      listen(button, 'click', function () {
        openSource(button.getAttribute('data-upload-source'), button);
      });
    });

    queryAll(root, '[data-upload-input]').forEach(function (input) {
      listen(input, 'change', function () {
        selectFile(input.files && input.files[0], input.getAttribute('data-upload-input'));
      });
    });

    listen(root, 'input', function (event) {
      var input = event.target.closest('[data-field-value]');
      if (!input || !reviewModel) return;
      var row = input.closest('[data-notice-field]');
      var index = Number(row && row.getAttribute('data-field-index'));
      var field = reviewModel.fields[index];
      if (!field || field.guardian_state === GUARDIAN_STATES.REMOVED) return;
      field.value = stringValue(input.value);
      field.guardian_state = GUARDIAN_STATES.MANUALLY_EDITED;
      updateGuardianBadge(row, GUARDIAN_STATES.MANUALLY_EDITED);
    });

    listen(root, 'change', function (event) {
      var checkbox = event.target.closest('[data-prep-item-toggle]');
      if (!checkbox) return;
      var index = Number(checkbox.getAttribute('data-prep-index'));
      if (!checklist[index]) return;
      checklist[index].checked = !!checkbox.checked;
      updatePrepProgress();
    });

    listen(root, 'click', function (event) {
      var actionNode = event.target.closest('[data-upload-action]');
      if (!actionNode || !root.contains(actionNode) || actionNode.disabled) return;
      var action = actionNode.getAttribute('data-upload-action');

      if (action === 'manual') {
        if (actionNode.closest('.lgu-source-grid')) lastSourceTrigger = actionNode;
        setState(UI_STATES.MANUAL, '已切換至手動建立清單');
      } else if (action === 'parse') {
        parseSelectedFile();
      } else if (action === 'retry') {
        retryLastOperation();
      } else if (action === 'cancel') {
        cancelRequest();
      } else if (action === 'remove') {
        removeFile();
      } else if (action === 'reselect') {
        openSource(selectedSource || 'library', lastSourceTrigger || actionNode);
      } else if (action === 'back-to-file' || action === 'review-back') {
        setState(selectedFile ? UI_STATES.FILE_SELECTED : UI_STATES.EMPTY, '返回通告');
      } else if (action === 'back-to-upload') {
        setState(UI_STATES.EMPTY, '返回上傳', { returnFocus: lastSourceTrigger });
      } else if (action === 'retry-online') {
        if (window.navigator.onLine) handleOnline();
        else announce('仍未恢復網絡連線');
      } else if (action === 'add-item') {
        addManualItem();
      } else if (action === 'edit-field') {
        var editRow = actionNode.closest('[data-notice-field]');
        var editInput = editRow && editRow.querySelector('[data-field-value]');
        if (editInput) {
          editInput.disabled = false;
          focusElement(editInput);
        }
      } else if (action === 'remove-field') {
        var removeRow = actionNode.closest('[data-notice-field]');
        var removeIndex = Number(removeRow && removeRow.getAttribute('data-field-index'));
        var removeField = reviewModel && reviewModel.fields[removeIndex];
        var removeInput = removeRow && removeRow.querySelector('[data-field-value]');
        if (removeField) {
          removeField.guardian_state = GUARDIAN_STATES.REMOVED;
          if (removeInput) removeInput.disabled = true;
          if (removeRow) removeRow.setAttribute('aria-disabled', 'true');
          updateGuardianBadge(removeRow, GUARDIAN_STATES.REMOVED);
          announce('已移除' + (removeField.label || removeField.key));
        }
      } else if (action === 'review-continue') {
        generatePackingList();
      } else if (action === 'packing-back') {
        renderReview();
        setState(UI_STATES.REVIEW, '返回確認通告內容');
      } else if (action === 'add-custom-packing-item') {
        if (!packingCustomInput) return;
        var customName = stringValue(packingCustomInput.value).trim();
        if (!customName) {
          announce('請輸入自訂物品');
          focusElement(packingCustomInput);
          return;
        }
        addPackingCustomItem(customName);
        packingCustomInput.value = '';
        announce('已加入 ' + customName);
        focusElement(packingCustomInput);
      } else if (action === 'remove-packing-item') {
        removePackingItem(actionNode.closest('[data-packing-item]'));
      } else if (action === 'packing-continue') {
        buildChecklist();
        setState(UI_STATES.PREP, '開始逐項核對');
      } else if (action === 'prep-back') {
        renderPacking();
        setState(UI_STATES.PACKING, '返回今日要帶咩');
      } else if (action === 'prep-continue') {
        renderConfirmSummary();
        setState(UI_STATES.CONFIRM, '請家長最終確認');
      } else if (action === 'confirm-back') {
        renderPrep();
        setState(UI_STATES.PREP, '返回逐項核對');
      } else if (action === 'confirm-notice') {
        confirmNotice();
      } else if (action === 'start-new-notice') {
        resetFlow();
      }
    });

    if (manualItemList) {
      listen(manualItemList, 'click', function (event) {
        var button = event.target.closest('[data-manual-remove-index]');
        if (!button) return;
        var index = Number(button.getAttribute('data-manual-remove-index'));
        if (!Number.isInteger(index) || index < 0 || index >= manualItems.length) return;
        var removed = manualItems.splice(index, 1)[0];
        renderManualItems();
        announce('已移除 ' + removed);
      });
    }

    if (manualItemInput) {
      listen(manualItemInput, 'keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        addManualItem();
      });
    }

    if (packingCustomInput) {
      listen(packingCustomInput, 'keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        var button = root.querySelector('[data-upload-action="add-custom-packing-item"]');
        if (button) button.click();
      });
    }

    if (manualForm) {
      listen(manualForm, 'submit', function (event) {
        event.preventDefault();
        promoteManualToPacking();
      });
    }

    listen(root, 'littleg:upload-confirmation-recovery', handleConfirmationRecovery);
    listen(window, 'offline', handleOffline);
    listen(window, 'online', handleOnline);
    workspaceBindings.set(root, { destroy: destroyBinding });
    setOfflineStatus(!window.navigator.onLine);
    setState(window.navigator.onLine ? UI_STATES.EMPTY : UI_STATES.OFFLINE, '', { focus: false });
    initialIntentTimer = window.setTimeout(applyInitialIntent, 0);
  }

  function boot(scope) {
    rootsIn(scope).forEach(bindWorkspace);
  }

  function destroy(scope) {
    rootsIn(scope).forEach(function (root) {
      var binding = workspaceBindings.get(root);
      if (binding && typeof binding.destroy === 'function') binding.destroy();
    });
  }

  function handleReady() { boot(document); }
  function handleSectionLoad(event) { boot(event.target || document); }
  function handleSectionUnload(event) { destroy(event.target || document); }
  function dispose() {
    destroy(document);
    document.removeEventListener('DOMContentLoaded', handleReady);
    document.removeEventListener('shopify:section:load', handleSectionLoad);
    document.removeEventListener('shopify:section:unload', handleSectionUnload);
  }

  window.LittleGUploadWorkspace = Object.freeze({
    VERSION: VERSION,
    UI_STATES: UI_STATES,
    RECOGNITION_STATES: RECOGNITION_STATES,
    GUARDIAN_STATES: GUARDIAN_STATES,
    RECOGNITION_LABELS: RECOGNITION_LABELS,
    GUARDIAN_LABELS: GUARDIAN_LABELS,
    MIME_BY_EXTENSION: MIME_BY_EXTENSION,
    LOADING_OPERATIONS: LOADING_OPERATIONS,
    maxFileSize: MAX_FILE_SIZE,
    validateFile: validateFile,
    createFieldModel: createFieldModel,
    normalizeParseResponse: normalizeParseResponse,
    normalizePackingResponse: normalizePackingResponse,
    boot: boot,
    destroy: destroy,
    dispose: dispose
  });

  document.addEventListener('shopify:section:load', handleSectionLoad);
  document.addEventListener('shopify:section:unload', handleSectionUnload);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleReady, { once: true });
  } else {
    boot(document);
  }
})(window, document);
